
(function () {
'use strict';
var root = document.getElementById('sbc-freestyle');
if (!root || root.getAttribute('data-fs-ready') === '1') { return; }
root.setAttribute('data-fs-ready', '1');

/* ======== EASY TO CHANGE ======== */
var WALL_TOTAL = 72413;                 /* Million Punch Wall count on the card (demo number)        */
var WALL_CAUSE = "NOW FOR PARKINSON'S"; /* cause after the count, a label only ('' hides it); up to ~20 characters fits one line */
var ROOM_TITLE = 'NEVER TRAIN ALONE';   /* room sheet title (the always-on room)                     */
/* Who is training when the demo opens. Fictional names only. flag = country emoji,
   lo/hi = that person's usual pace (punches a second), hue = graph colour (app palette). */
var START_ROOM = [
	{ name: 'KoaOnTheBag', flag: '🇯🇵', lo: 9.6, hi: 11.0, total: 2140, from: 24, hue: '#E07BA8' },
	{ name: 'LeftHookLena', flag: '🇬🇧', lo: 8.9, hi: 10.2, total: 316, from: 16, hue: '#B07BE0' },
	{ name: 'RhythmRiley', flag: '🇺🇸', lo: 5.9, hi: 7.2, total: 1066, from: 2, hue: '#6FB6FF' }
];
/* "Fill the room" arrivals, in arrival order. Fictional names only. */
var ARRIVALS = [
	{ name: 'SwivelSam', flag: '🇦🇺', lo: 6.6, hi: 8.6 },
	{ name: 'TripleTess', flag: '🇨🇦', lo: 8.2, hi: 10.4 },
	{ name: 'GarageGloves', flag: '🇺🇸', lo: 5.2, hi: 7.0 },
	{ name: 'NightShiftNia', flag: '🇳🇿', lo: 7.2, hi: 9.2 },
	{ name: 'ReboundRio', flag: '🇧🇷', lo: 8.8, hi: 11.2 },
	{ name: 'PlatformPaz', flag: '🇲🇽', lo: 4.6, hi: 6.4 },
	{ name: 'BagWorkBex', flag: '🇩🇪', lo: 6.8, hi: 8.8 }
];
/* Both apps show at most 10 other people, so START_ROOM + ARRIVALS stays at 10. */
/* ======== (end) ======== */

var PALETTE = ['#6FB6FF', '#B07BE0', '#E07BA8', '#7FD08A', '#D9DEF5'];
var PROPS = ['👏 Good work', '🔥 Keep it rolling', '⚡ Clean rhythm', '💪 Strong round',
	'🙌 Glad you showed up', '🙏 Thanks for not training alone', '🎯 Lock in', '🚀 Finish strong'];
var LANES = [{ lo: 5, hi: 7, t: 'Cruise' }, { lo: 7, hi: 9, t: 'Classic' }, { lo: 9, hi: 11, t: 'Fast' }];
var TIPS = [
	['👆', 'TAP ANYONE’S LINE OR NAME', 'Send props or challenge them to a race'],
	['🤝', 'BUILD EACH OTHER UP', 'Props land on their screen instantly'],
	['🏁', 'RACE EACH OTHER', 'Tap a name, then CHALLENGE TO A RACE'],
	['🎯', '', 'Tap it to change your pocket speed']
];
var TIER_WORD = ['WARM UP', 'HEATING UP', 'ON FIRE', 'IN THE POCKET'];
var TIER_LINE = ['#F0A940', '#FFD157', '#FF6123', '#7CF2E4'];
var TIER_ARC = [['rgba(255,255,255,.55)', 'rgba(255,255,255,.25)'], ['#DB8C29', 'rgba(219,140,41,.7)'], ['#FF6123', 'rgba(255,97,35,.95)'], ['#7CF2E4', 'rgba(124,242,228,.9)']];
var DOT = ' · ';
var SANS = 'system-ui,-apple-system,BlinkMacSystemFont,"SF Pro Text","Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif';
var TAGFONT = '800 9px ' + SANS;
var RD = '\u2060–\u2060';

var DW = 375, DH = 744, CW = 347;
var HZ = 30, DT = 1 / HZ, COL = 0.25, NCOL = 246, HEAD = 50;
var TAU = Math.PI * 2;

var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
var reduced = !!(mq && mq.matches);

function q(sel, el) { return (el || root).querySelector(sel); }
function qa(sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); }
function rnd(a, b) { return a + Math.random() * (b - a); }
function clamp(v, a, b) { return v < a ? a : (v > b ? b : v); }
function gauss() { var u = 1 - Math.random(), v = Math.random(); return Math.sqrt(-2 * Math.log(u)) * Math.cos(TAU * v); }
function fmt(n) { return Math.max(0, Math.floor(n)).toLocaleString('en-US'); }
function mss(sec) {
	sec = Math.max(0, Math.floor(sec));
	var h = Math.floor(sec / 3600), m = Math.floor(sec / 60) % 60, s = sec % 60;
	return (h ? h + ':' + (m < 10 ? '0' : '') : '') + m + ':' + (s < 10 ? '0' : '') + s;
}
function esc(s) {
	return String(s).replace(/[&<>"']/g, function (c) {
		return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
	});
}
function hexA(hex, a) {
	var n = parseInt(hex.slice(1), 16);
	return 'rgba(' + (n >> 16 & 255) + ',' + (n >> 8 & 255) + ',' + (n & 255) + ',' + a + ')';
}
function seams(name, upper) {
	var parts = String(name).replace(/([a-z0-9])([A-Z])/g, '$1\u0001$2').replace(/([._\-])/g, '$1\u0001').split('\u0001');
	return parts.map(function (p) { return esc(upper ? p.toUpperCase() : p); }).join('<wbr>');
}
function tagOf(name) { return String(name).split(/[ ._\-]/)[0].slice(0, 6).toUpperCase(); }
function emojiOf(phrase) { return phrase.split(' ')[0]; }
function wordsOf(phrase) { return phrase.slice(phrase.indexOf(' ') + 1); }
function accentOf(emoji) { return emoji === '🔥' ? '#FF782E' : (emoji === '⚡' ? '#52C7FF' : (emoji === '💪' ? '#6BE094' : '#FFC242')); }
function slot(str) {
	var h = '';
	for (var i = 0; i < str.length; i++) {
		var c = str.charAt(i);
		h += '<span class="fs-sc' + (c === ',' || c === ':' || c === '.' ? ' fs-sn' : '') + '">' + esc(c) + '</span>';
	}
	return h;
}
function setSlot(el, str) { if (el && el._v !== str) { el._v = str; el.innerHTML = slot(str); } }
function setText(el, str) { if (el && el._t !== str) { el._t = str; el.textContent = str; } }
function restartAnim(el, cls) {
	if (reduced || !el) { return; }
	el.classList.remove(cls); void el.offsetWidth; el.classList.add(cls);
}
var mctx = document.createElement('canvas').getContext('2d');
function focusQ(n) { try { n.focus({ preventScroll: true }); } catch (e) { n.focus(); } }
function textW(str, font, kern) { mctx.font = font; return mctx.measureText(str).width + (kern || 0) * str.length; }

var el = {
	phone: q('.fs-phone'), fit: q('.fs-fit'), stage: q('.fs-stage'), card: q('.fs-card'), plot: q('.fs-plot'),
	cv: q('.fs-cv'), dcv: q('.fs-dcv'), paceN: q('.fs-pace-n'), pill: q('.fs-pill'), badge: q('.fs-badge'),
	streak: q('.fs-streak'), streakN: q('.fs-streak-n'), peak: q('.fs-peak'), flowK: q('.fs-flow-k'), flow: q('.fs-flow'),
	prompt: q('.fs-prompt'), strip: q('.fs-strip'), chips: q('.fs-chips'), ev: q('.fs-ev'), roomPill: q('.fs-roompill'),
	wallN: q('.fs-wall-n'), wallC: q('.fs-wall-c'), wallM: q('.fs-wall-m'), wallBar: q('.fs-wall-bar i'), wallG: q('.fs-wall-g'), wallR: q('.fs-wall-r'),
	count: q('.fs-count'), clock: q('.fs-clock'), nav: q('.fs-nav'), lower: q('.fs-lower'), expand: q('.fs-expand'), stop2: q('.fs-stop2'),
	menu: q('.fs-menu'), catcher: q('.fs-catch'), scrim: q('.fs-scrim'), sheet: q('.fs-sheet'), shEye: q('.fs-sh-eye'), shTitle: q('.fs-sh-title'),
	shTools: q('.fs-sh-tools'), search: q('.fs-sh-search'), list: q('.fs-sh-list'), shTotal: q('.fs-sh-tv'), shClose: q('.fs-sh-x'),
	note: q('.fs-note'), status: q('.fs-status-t'), statusBox: q('.fs-status'), tagT: q('.fs-tag-t')
};
var pctx = el.cv.getContext('2d'), dctx = el.dcv.getContext('2d');

var T = 0, colT = 0, colAcc = 0, secAcc = 0;
var laneIdx = 1, lane = LANES[1], laneLoD = 7, laneHiD = 9;
function laneMid() { return (lane.lo + lane.hi) / 2; }

function mkAth(o, you) {
	var ring = new Float64Array(16);
	for (var i = 0; i < 16; i++) { ring[i] = -99; }
	return {
		name: o.name, flag: o.flag || '', lo: o.lo || 6, hi: o.hi || 9, you: !!you, from: o.from || 0,
		tempo: 0, target: 0, ou: 0, next: 0, ring: ring, ri: 0, sm: 0, total: o.total || 0, lastHit: -99,
		hist: new Float32Array(NCOL), hn: 0, hh: 0, pts: new Float32Array((NCOL + 2) * 2),
		mode: 'free', focus: 0, until: 0, hue: o.hue || null, joined: 0, leaving: false, alpha: 1, flash: -9,
		inSince: -1, considered: false, fireT: 11
	};
}
var you = mkAth({ name: 'YOU' }, true);
var room = [];
var gone = [];
var worn = {};
var session = { hits: 0, peak: 0, flow: 0, best: 0, inPocket: false, tier: 0, lastTier: 0 };
var gate = { lastAt: -999, by: {} };
var jobs = [];
var lastIncoming = -999, tipsOn = true, tipI = 0, tipNext = 0;
var prompt = { ev: null };
var stripEv = null;
var hintShown = false, pendingBuddy = null;
var announced = {}, arrivalOrder = [];
var sheetOpen = false, sheetTouch = 0, sheetFocus = null, sheetOpener = null, expandedName = null, sheetFilter = 'all';
var rowsSig = '', sheetVis = true;

function later(sec, fn, tag) { jobs.push({ at: T + sec, fn: fn, tag: tag || '' }); }
function cancelJobs(tag) { jobs = jobs.filter(function (j) { return j.tag !== tag; }); }
function runJobs() {
	for (var i = 0; i < jobs.length; i++) {
		if (jobs[i].at <= T) { var j = jobs.splice(i, 1)[0]; i--; j.fn(); }
	}
}

function pickHue() {
	var used = {}, i;
	room.forEach(function (p) { if (p.hue) { used[p.hue] = 1; } });
	for (i = 0; i < PALETTE.length; i++) { if (!used[PALETTE[i]] && !worn[PALETTE[i]]) { return PALETTE[i]; } }
	for (i = 0; i < PALETTE.length; i++) { if (!used[PALETTE[i]]) { return PALETTE[i]; } }
	return null;
}
var known = {};
function addPartner(def, cue) {
	var p = known[def.name], i = gone.indexOf(p);
	if (i >= 0) { gone.splice(i, 1); }
	if (!p) { p = known[def.name] = mkAth(def, false); } else { p.leaving = false; p.alpha = 1; p.hn = 0; p.flash = -9; }
	p.hue = def.hue && !room.some(function (r) { return r.hue === def.hue; }) ? def.hue : pickHue();
	if (p.hue) { worn[p.hue] = 1; }
	p.joined = T; p.from = T + rnd(0.2, 1.2); p.mode = 'free'; p.until = 0; p.tempo = 0; p.sm = 0;
	p.inSince = -1; p.considered = false;
	room.push(p);
	if (cue && !announced[p.name]) {
		strip({ name: p.name, tail: ' JOINED', accent: '#FFD157', dur: 2.5 });
		arrivalOrder.push(p.name);
	}
	announced[p.name] = 1;
	roomChanged();
	return p;
}
function removePartner(p) {
	var i = room.indexOf(p);
	if (i < 0) { return; }
	room.splice(i, 1);
	p.leaving = true; p.alpha = 1;
	gone.push(p);
	if (pendingBuddy === p) { pendingBuddy = null; }
	if (expandedName === p.name) { expandedName = null; }
	roomChanged();
}
function charted() { return room.slice(0, 6); }

function ouStep(a, s) { a.ou += -a.ou * DT / 2.2 + s * Math.sqrt(DT) * gauss(); }
function directYou() {
	var a = you;
	if (a.mode === 'fire' && T > a.until) { a.mode = 'free'; a.focus = laneMid(); a.until = T + rnd(9, 14); }
	if (a.mode === 'pocket' && T > a.until) { a.mode = 'free'; a.focus = laneMid() + rnd(-0.25, 0.25); a.until = T + rnd(5, 9); }
	if (a.mode === 'free' && T >= a.until) {
		var r = Math.random();
		if (r < 0.62) { a.focus = laneMid() + rnd(-0.3, 0.3); a.until = T + rnd(11, 18); }
		else if (r < 0.82) { a.focus = Math.min(11.5, lane.hi + rnd(0.7, 1.4)); a.until = T + rnd(4, 7); }
		else { a.focus = Math.max(3.2, lane.lo - rnd(0.9, 2)); a.until = T + rnd(4, 7); }
	}
	ouStep(a, 0.42);
	if (a.mode === 'fire') { a.target = a.fireT + a.ou * 0.35; }
	else if (a.mode === 'pocket') { a.target = laneMid() + a.ou * 0.12; }
	else if (a.mode === 'script') { a.target = a.focus + a.ou * 0.3; }
	else { a.target = a.focus + a.ou * 0.55; }
	a.target = clamp(a.target, 0, 12.4);
}
function directPartner(a) {
	if (a.leaving) { a.target = 0; return; }
	if (T < a.from) { a.target = 0; return; }
	if (a.mode === 'drive') {
		if (T > a.until) { a.mode = 'free'; a.until = 0; if (pendingBuddy === a) { pendingBuddy = null; } }
		else { ouStep(a, 0.3); a.target = laneMid() + a.ou * 0.08; return; }
	}
	if (a.mode === 'rest') {
		if (T > a.until) { a.mode = 'free'; a.until = 0; a.from = T; } else { a.target = 0; return; }
	}
	if (T >= a.until) {
		if (Math.random() < 0.025 && T - a.joined > 30) { a.mode = 'rest'; a.until = T + rnd(3, 6); a.target = 0; return; }
		a.focus = rnd(a.lo, a.hi); a.until = T + rnd(7, 16);
	}
	ouStep(a, 0.45);
	a.target = clamp((a.focus + a.ou * 0.6) * clamp((T - a.from) / 7, 0.2, 1), 0, 12.8);
}
function stepAth(a) {
	var tau = a.mode === 'drive' ? 0.6 : (a.target < 0.5 ? 0.3 : 0.9);
	a.tempo += (a.target - a.tempo) * (1 - Math.exp(-DT / tau));
	if (a.tempo < 0.4) { a.next = T + 0.3; }
	else {
		while (a.next <= T) {
			a.ring[a.ri] = a.next; a.ri = (a.ri + 1) & 15; a.total++; a.lastHit = a.next;
			if (a.you) { onYourHit(); }
			a.next += (1 / a.tempo) * (1 + gauss() * 0.07);
		}
	}
	var raw = 0;
	for (var i = 0; i < 16; i++) { if (a.ring[i] > T - 1) { raw++; } }
	a.sm += (raw - a.sm) * (raw > a.sm ? 0.35 : 0.12);
	if (a.sm < 0.02) { a.sm = 0; }
	if (a.sm > 13) { a.sm = 13; }
}
function pushCol(a) { a.hh = (a.hh + 1) % NCOL; a.hist[a.hh] = a.sm; if (a.hn < NCOL) { a.hn++; } }
function inLane(v) { return v >= lane.lo && v <= lane.hi; }
function onYourHit() {
	session.hits++;
	if (session.hits % 100 === 0) { restartAnim(el.wallG, 'is-pulse'); }
}

function simStep() {
	T += DT;
	runJobs();
	directYou(); stepAth(you);
	var i;
	for (i = 0; i < room.length; i++) { directPartner(room[i]); stepAth(room[i]); }
	for (i = gone.length - 1; i >= 0; i--) {
		var g = gone[i]; g.alpha -= DT / 0.8;
		if (g.alpha <= 0) { gone.splice(i, 1); }
	}
	var inP = inLane(you.sm) && T - you.lastHit <= 0.8;
	session.inPocket = inP;
	session.flow = inP ? session.flow + DT : 0;
	if (session.flow > session.best) { session.best = session.flow; }
	if (you.sm > session.peak) { session.peak = you.sm; }
	session.tier = inP ? 3 : (you.sm >= 9.5 ? 2 : (you.sm >= 4 ? 1 : 0));
	var k = reduced ? 1 : 1 - Math.exp(-DT / 0.12);
	laneLoD += (lane.lo - laneLoD) * k; laneHiD += (lane.hi - laneHiD) * k;
	colAcc += DT;
	if (colAcc >= COL) {
		colAcc -= COL; colT = T;
		pushCol(you);
		for (i = 0; i < room.length; i++) { if (T >= room[i].joined) { pushCol(room[i]); } }
	}
	secAcc += DT;
	if (secAcc >= 1) { secAcc -= 1; tick1s(); }
	if (prompt.ev && T >= prompt.ev.until) { prompt.ev = null; }
	if (tipsOn && !prompt.ev && room.length && T >= tipNext) { tipI = (tipI + 1) % TIPS.length; tipNext = T + 4.5; }
	if (stripEv && T >= stripEv.until) { stripEv = null; }
	if (sheetOpen && !sheetVis) { sheetTouch = T; }
	if (sheetOpen && T - sheetTouch > 8) { closeSheet(false); }
}

function tick1s() {
	var fire = null;
	room.forEach(function (p) {
		if (T - p.lastHit > 4 || !inLane(p.sm)) { p.inSince = -1; p.considered = false; return; }
		if (p.inSince < 0) { p.inSince = T; }
		if (T - p.inSince < 2 || p.considered) { return; }
		p.considered = true;
		if (pendingBuddy && p !== pendingBuddy) { return; }
		if (fire || T - gate.lastAt < 20 || T - (gate.by[p.name] || -999) < 60) { return; }
		fire = p;
	});
	if (fire && !prompt.ev && !sheetOpen) {
		gate.lastAt = T; gate.by[fire.name] = T;
		var lead = ['🎯 Lock in', '🔥 Keep it rolling', '⚡ Clean rhythm'][Math.floor(Math.random() * 3)];
		prompt.ev = { who: fire, props: [lead, '👏 Good work'], until: T + 8 };
		promptSig = '';
		restartAnim(el.prompt, 'is-glow');
		if (pendingBuddy === fire) { say(fire.name + ' hit the pocket. Send props with one tap, right from the card.'); }
		pendingBuddy = null;
	}
	if (room.length && session.flow > 10 && T - lastIncoming > 45 && Math.random() < 0.1) {
		var from = room[Math.floor(Math.random() * room.length)];
		if (T - from.joined > 5) { receiveProps(from, PROPS[[0, 2, 6, 3][Math.floor(Math.random() * 4)]]); }
	}
}

function strip(o) {
	var h = '';
	if (o.emoji) { h += '<span class="fs-e">' + esc(o.emoji) + ' </span>'; }
	if (o.lead) { h += '<span class="fs-k">' + esc(o.lead) + '</span>'; }
	var hw = h;
	if (o.name) { h += '<span class="fs-n">' + esc(o.name) + '</span>'; hw += '<span class="fs-n">' + seams(o.name) + '</span>'; }
	if (o.tail) { h += '<span class="fs-k">' + esc(o.tail) + '</span>'; hw += '<span class="fs-k">' + esc(o.tail) + '</span>'; }
	stripEv = { html: h, htmlW: hw, until: T + o.dur, accent: o.accent, name: !!o.name, tail: o.tail || '' };
	stripSig = '';
	el.roomPill.style.setProperty('--pa', hexA(o.accent.charAt(0) === '#' ? o.accent : '#FFD157', 0.85));
	restartAnim(el.roomPill, 'is-pulse');
}
function sendProps(p, phrase, from) {
	var e = emojiOf(phrase);
	strip({ emoji: e, lead: 'SENT TO ', name: p.name, accent: accentOf(e), dur: 1.4 });
	if (from === 'bar') { prompt.ev = null; promptSig = ''; }
	if (from === 'row') { flashRow(p.name); sheetTouch = T; }
	say(wordsOf(phrase) + ' sent to ' + p.name + '. It lands on their screen.');
	if (Math.random() < 0.6 && T - lastIncoming > 12) {
		var who = p;
		later(rnd(3, 5.5), function () { if (room.indexOf(who) >= 0) { receiveProps(who, PROPS[[0, 4, 5, 1][Math.floor(Math.random() * 4)]]); } }, 'reply');
	}
}
function receiveProps(p, phrase) {
	lastIncoming = T;
	var e = emojiOf(phrase);
	strip({ emoji: e, name: p.name, tail: DOT + wordsOf(phrase).toUpperCase(), accent: accentOf(e), dur: 2.2 });
}
function flashRow(name) {
	var r = rowFor(name);
	if (!r) { return; }
	r.classList.add('is-sent');
	clearTimeout(r._ft);
	r._ft = setTimeout(function () { r.classList.remove('is-sent'); }, 850);
}
var noteTimer = 0;
function note(title, body) {
	el.note.innerHTML = '<b>' + esc(title) + '</b>' + esc(body);
	el.note.hidden = false;
	clearTimeout(noteTimer);
	noteTimer = setTimeout(function () { el.note.hidden = true; }, 4200);
}
var sayTimer = 0;
function say(msg) {
	clearTimeout(sayTimer);
	el.status.textContent = '';
	sayTimer = setTimeout(function () { el.status.textContent = msg; }, 60);
}

function reveal(top, bottom) {
	var vh = window.innerHeight || document.documentElement.clientHeight || 0, d = 0;
	if (!vh) { return; }
	if (bottom > vh - 16) { d = bottom - (vh - 16); }
	if (top - d < 76) { d = top - 76; }
	if (Math.abs(d) < 4) { return; }
	try { window.scrollBy({ top: d, left: 0, behavior: reduced ? 'auto' : 'smooth' }); } catch (e) { window.scrollBy(0, d); }
}
function revealCard() {
	var c = el.card.getBoundingClientRect(), s = el.statusBox.getBoundingClientRect();
	var vh = window.innerHeight || 0, top = s.bottom <= c.top && c.bottom - s.top <= vh - 92 ? s.top : c.top;
	reveal(top, c.bottom);
}
function revealSheet() {
	var ph = el.phone.getBoundingClientRect(), t = el.sheet.offsetTop * scale;
	reveal(ph.top + t, ph.top + t + el.sheet.offsetHeight * scale);
}

var menuOpen = false, menuDemo = 0;
function openMenu(focusIt) {
	closeSheet(false);
	menuOpen = true;
	var pr = el.pill, x = pr.offsetLeft + pr.offsetWidth, y = pr.offsetHeight + 6, n = pr;
	while (n && n !== el.phone) { y += n.offsetTop; if (n !== pr) { x += n.offsetLeft; } n = n.offsetParent; }
	el.menu.style.left = Math.round(Math.min(DW - 250, x - 238)) + 'px';
	el.menu.style.top = Math.round(y) + 'px';
	qa('.fs-mi', el.menu).forEach(function (b) {
		b.setAttribute('aria-checked', +b.getAttribute('data-lane') === laneIdx ? 'true' : 'false');
		b.classList.remove('is-hi'); b.tabIndex = -1;
	});
	el.menu.hidden = false;
	restartAnim(el.menu, 'is-in');
	el.pill.setAttribute('aria-expanded', 'true');
	if (focusIt) { var c = q('.fs-mi[aria-checked="true"]', el.menu); if (c) { c.focus(); } }
}
function closeMenu(refocus) {
	if (!menuOpen) { return; }
	menuOpen = false; clearTimeout(menuDemo);
	var had = el.menu.contains(document.activeElement);
	el.menu.hidden = true;
	el.pill.setAttribute('aria-expanded', 'false');
	if (had || refocus) { focusQ(el.pill); }
}
function setLane(i, announce) {
	laneIdx = i; lane = LANES[i];
	if (reduced) { laneLoD = lane.lo; laneHiD = lane.hi; }
	you.mode = 'pocket'; you.until = T + 12;
	session.flow = 0;
	promptSig = '';
	for (var k = 0; k < room.length; k++) { room[k].inSince = -1; room[k].considered = true; }
	if (announce) { say('Pocket Speed: ' + lane.t + DOT + lane.lo + RD + lane.hi + ' P/S. The teal lane moves, and IN THE POCKET follows it.'); }
}

function sheetTopLimit() {
	return el.phone.classList.contains('is-exp') ? DH * 0.4 : el.card.offsetTop + el.card.offsetHeight + 8;
}
function openSheet(focusName, fromInside) {
	closeMenu(false);
	if (!sheetOpen) {
		sheetOpen = true;
		sheetOpener = fromInside && root.contains(document.activeElement) ? document.activeElement : null;
		el.search.value = ''; sheetFilter = 'all';
		qa('.fs-flt').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-f') === 'all' ? 'true' : 'false'); });
		el.sheet.hidden = false; el.scrim.hidden = false; el.catcher.hidden = false;
		restartAnim(el.sheet, 'is-in');
		[el.nav, el.card, el.lower].forEach(function (n) { n.inert = true; n.setAttribute('aria-hidden', 'true'); });
	}
	sheetTouch = T;
	expandedName = focusName || null;
	rowsSig = '';
	layoutSheet();
	renderSheet(true);
	if (focusName) {
		var r = rowFor(focusName);
		if (r) { el.list.scrollTop = Math.max(0, r.offsetTop - el.list.offsetTop - 8); }
	} else { el.list.scrollTop = 0; }
	if (fromInside) {
		var f = focusName && rowFor(focusName) ? q('.fs-row-tog', rowFor(focusName)) : el.shClose;
		focusQ(f);
	}
	revealSheet();
}
function closeSheet(user) {
	if (!sheetOpen) { return; }
	sheetOpen = false;
	var hadFocus = el.sheet.contains(document.activeElement);
	el.sheet.hidden = true; el.scrim.hidden = true; el.catcher.hidden = true;
	[el.nav, el.card, el.lower].forEach(function (n) { n.inert = false; n.removeAttribute('aria-hidden'); });
	if (hadFocus || user) {
		var t = sheetOpener && root.contains(sheetOpener) && !sheetOpener.closest('[hidden]') ? sheetOpener : el.roomPill;
		if (hadFocus) { focusQ(t); }
	}
	sheetOpener = null;
	if (you.mode === 'free') { you.until = Math.min(you.until, T + 2); }
}
function layoutSheet() {
	var top = sheetTopLimit();
	el.sheet.style.maxHeight = (DH - top - 8) + 'px';
	el.scrim.style.top = (top - 8) + 'px';
	el.catcher.style.height = (top - 8) + 'px';
}
function rowFor(name) {
	var rows = qa('.fs-row', el.list);
	for (var i = 0; i < rows.length; i++) { if (rows[i].getAttribute('data-n') === name) { return rows[i]; } }
	return null;
}
function colourOf(p) { return p.hue || '#FFFFFF'; }
function newest3() {
	return arrivalOrder.map(byName).filter(function (p) { return !!p; }).slice(-3);
}
function renderSheet(force) {
	var n = room.length;
	setText(el.shEye, n ? 'LIVE IN THE ROOM' + DOT + n : 'LIVE IN THE ROOM');
	setText(el.shTitle, ROOM_TITLE);
	var tools = n >= 5;
	if (el.shTools.hidden === tools) {
		el.shTools.hidden = !tools;
		if (!tools) { el.search.value = ''; sheetFilter = 'all'; qa('.fs-flt').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-f') === 'all' ? 'true' : 'false'); }); }
	}
	var needle = el.search.value.trim().toLowerCase(), nw = newest3();
	var rows = room.filter(function (p) {
		if (needle && p.name.toLowerCase().indexOf(needle) < 0) { return false; }
		if (sheetFilter === 'pocket' && !inLane(p.sm)) { return false; }
		if (sheetFilter === 'new' && nw.indexOf(p) < 0) { return false; }
		return true;
	});
	var sig = rows.map(function (p) { return p.name + (p.hue || ''); }).join('|') + '#' + n + sheetFilter + needle + expandedName;
	if (force || sig !== rowsSig) {
		rowsSig = sig;
		var keep = el.list.scrollTop, h = '';
		if (!n) {
			h = '<div class="fs-sh-empty">Nobody else is live right now. Invite a friend and bag together — every line on the graph is a real person.</div>';
		} else if (!rows.length) {
			h = '<div class="fs-sh-empty">' + (sheetFilter === 'new' && !needle ? 'Nobody new yet — new arrivals show here.' : 'Nobody matches. Clear the search or pick ALL.') + '</div>';
		}
		rows.forEach(function (p) {
			var c = colourOf(p), open = expandedName === p.name, id = 'sbcfs-pp-' + room.indexOf(p);
			h += '<div class="fs-row' + (open ? ' is-open' : '') + '" data-n="' + esc(p.name) + '" style="--c:' + (p.hue ? c : 'rgba(255,255,255,.6)') + ';--cb:' + hexA(c, p.hue ? 0.1 : 0.05) + ';--cr:' + hexA(c, p.hue ? 0.42 : 0.2) + ';--cf:' + hexA(c, 0.14) + '">' +
				'<div class="fs-row-main"><button type="button" class="fs-row-tog" aria-expanded="' + open + '" aria-controls="' + id + '"><span class="fs-av" aria-hidden="true">' + esc(p.flag || p.name.charAt(0)) + '</span>' +
				'<span class="fs-row-id"><span class="fs-row-n">' + seams(p.name) + '</span><span class="fs-row-d"></span></span></button>' +
				'<button type="button" class="fs-qp" data-p="0" aria-label="Send Good work to ' + esc(p.name) + '">👏</button>' +
				'<button type="button" class="fs-qp" data-p="1" aria-label="Send Keep it rolling to ' + esc(p.name) + '">🔥</button>' +
				'<button type="button" class="fs-chev" tabindex="-1" aria-hidden="true"><svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6l5 5 5-5"/></svg></button></div>' +
				'<span class="fs-row-tag" hidden>IN POCKET</span>' +
				'<span class="fs-row-ok" aria-hidden="true"><svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="11" fill="currentColor"/><path d="M7 12.4l3.2 3.2L17.2 8.6" fill="none" stroke="#1A263D" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' +
				'<div class="fs-panel" id="' + id + '"' + (open ? '' : ' hidden') + ' role="group" aria-label="Props for ' + esc(p.name) + '">' +
				PROPS.map(function (ph, i) { return '<button type="button" class="fs-pp" data-p="' + i + '">' + esc(ph) + '</button>'; }).join('') +
				'<button type="button" class="fs-race" data-act="race">🏁 CHALLENGE TO A RACE</button></div></div>';
		});
		var had = el.list.contains(document.activeElement) && document.activeElement.closest('.fs-row') ? document.activeElement : null;
		var hk = had && [had.closest('.fs-row').getAttribute('data-n'), '.' + had.classList[0] + (had.hasAttribute('data-p') ? '[data-p="' + had.getAttribute('data-p') + '"]' : '')];
		el.list.innerHTML = h;
		el.list.scrollTop = keep;
		qa('.fs-row-n', el.list).forEach(fitName);
		var fr = hk && rowFor(hk[0]), ft = fr && q(hk[1], fr);
		if (ft) { focusQ(ft); }
	}
	qa('.fs-row', el.list).forEach(function (r) {
		var p = byName(r.getAttribute('data-n'));
		if (!p) { return; }
		setText(q('.fs-row-d', r), p.sm.toFixed(1) + ' P/S' + DOT + fmt(p.total) + ' HITS');
		var tg = q('.fs-row-tag', r), on = inLane(p.sm) && T - p.lastHit < 4;
		if (tg.hidden === on) { tg.hidden = !on; }
	});
	setText(el.shTotal, fmt(roomTotal()));
}
function fitName(n) {
	var sizes = [15, 14, 13];
	for (var i = 0; i < sizes.length; i++) {
		n.style.fontSize = sizes[i] + 'px';
		if (n.scrollWidth <= n.clientWidth + 0.5 && n.offsetHeight < sizes[i] * 1.5) { return; }
	}
	n.style.fontSize = '13px';
}
function byName(name) {
	for (var i = 0; i < room.length; i++) { if (room[i].name === name) { return room[i]; } }
	return null;
}
function roomTotal() {
	var t = session.hits;
	room.forEach(function (p) { t += p.total; });
	return t;
}

function roomChanged() {
	stripSig = ''; promptSig = '';
	var n = room.length;
	el.cv.setAttribute('aria-label', 'Pace graph: your line' + (n ? ' and ' + Math.min(6, n) + ' partner line' + (Math.min(6, n) > 1 ? 's' : '') : '') + ' over the teal pocket lane. Tap a line to open that person.');
	if (sheetOpen) { renderSheet(false); }
	syncToggles();
}
function syncToggles() {
	var full = room.length >= 10, solo = room.length === 0 && !jobs.some(function (j) { return j.tag === 'arrive'; });
	var c = q('[data-sc="crowd"]'), s = q('[data-sc="solo"]');
	setText(q('.fs-try-t', c), full ? 'Back to 4 people' : 'Fill the room');
	setText(q('.fs-try-s', c), full ? 'The newcomers head out' : '11 people. The graph keeps 6 partner lines');
	setText(q('.fs-try-t', s), solo ? 'Back to the room' : 'Train solo');
	setText(q('.fs-try-s', s), solo ? 'Three people come back on' : 'Nobody else on? Invite a friend');
}
function everyoneLeaves() {
	cancelJobs('arrive');
	room.slice().forEach(removePartner);
	prompt.ev = null;
}
function restoreBase(stagger) {
	START_ROOM.forEach(function (d, i) {
		if (byName(d.name)) { return; }
		if (stagger) { later(0.4 + i * 0.8, function () { if (!byName(d.name)) { addPartner(d, true); } }, 'arrive'); }
		else { addPartner(d, true); }
	});
}

var scale = 1, PH = 142, dpr = 1, dialStatic = null;
function fitCanvas(cv, w, h) {
	var r = dpr * scale, bw = Math.max(1, Math.round(w * r)), bh = Math.max(1, Math.round(h * r));
	if (cv.width !== bw || cv.height !== bh) { cv.width = bw; cv.height = bh; }
	cv._r = r;
}
function Yof(v, base, span) { v = v < 2 ? 2 : (v > 13 ? 13 : v); return base - (v - 2) / 11 * span; }
function buildPts(a, ax, pxs, base, span) {
	var n = a.hn, j = 0, age0 = T - colT, p = a.pts;
	for (var k = n - 1; k >= 0; k--) {
		var x = ax - (age0 + k * COL) * pxs;
		if (x < -3) { continue; }
		p[j++] = x; p[j++] = Yof(a.hist[(a.hh - k + NCOL) % NCOL], base, span);
	}
	p[j++] = ax; p[j++] = Yof(a.sm, base, span);
	return j >> 1;
}
function trace(c, p, n) {
	c.beginPath(); c.moveTo(p[0], p[1]);
	for (var i = 1; i < n - 1; i++) {
		c.quadraticCurveTo(p[2 * i], p[2 * i + 1], (p[2 * i] + p[2 * i + 2]) / 2, (p[2 * i + 1] + p[2 * i + 3]) / 2);
	}
	if (n > 1) { c.lineTo(p[2 * n - 2], p[2 * n - 1]); }
}
var tagBoxes = [];
function drawPlot() {
	var c = pctx, r = el.cv._r || 1, w = CW, h = PH, base = h - 2, span = base - HEAD, i;
	c.setTransform(r, 0, 0, r, 0, 0);
	c.clearRect(0, 0, w, h);
	var inP = session.tier === 3;
	var yh = Yof(laneHiD, base, span), yl = Yof(laneLoD, base, span);
	var g = c.createLinearGradient(0, yh - 8, 0, yl + 8);
	g.addColorStop(0, 'rgba(124,242,228,0)'); g.addColorStop(0.5, inP ? 'rgba(124,242,228,.4)' : 'rgba(124,242,228,.18)'); g.addColorStop(1, 'rgba(124,242,228,0)');
	c.fillStyle = g; c.fillRect(0, yh - 8, w, yl - yh + 16);
	c.setLineDash([10, 8]); c.lineDashOffset = reduced ? 0 : (T * 40) % 18;
	c.strokeStyle = inP ? 'rgba(124,242,228,.9)' : 'rgba(124,242,228,.7)'; c.lineWidth = inP ? 2 : 1.5;
	c.beginPath(); c.moveTo(0, yh); c.lineTo(w, yh); c.moveTo(0, yl); c.lineTo(w, yl); c.stroke();
	c.setLineDash([]);
	c.strokeStyle = 'rgba(255,255,255,.26)'; c.lineWidth = 1;
	c.beginPath(); c.moveTo(0, base + 0.5); c.lineTo(w, base + 0.5); c.stroke();
	var ax = w * 0.8, pxs = ax / 60, list = charted().concat(gone.filter(function (x) { return x.hn; }));
	tagBoxes.length = 0;
	c.lineJoin = 'round'; c.lineCap = 'round';
	for (i = 0; i < list.length; i++) {
		var a = list[i];
		if (!a.hn || T < a.joined) { continue; }
		var n = buildPts(a, ax, pxs, base, span), thin = !a.hue, col = a.hue || '#FFFFFF';
		var ft = T - a.flash, hot = ft >= 0 && ft < 0.9;
		c.globalAlpha = a.alpha * (hot ? 1 : (thin ? 0.36 : 0.85));
		c.strokeStyle = hot ? '#FFFFFF' : col;
		c.lineWidth = hot ? (reduced ? 3.5 : (thin ? 1 : 1.5) + ((3.5 - (thin ? 1 : 1.5)) * Math.sin(Math.PI * ft / 0.9))) : (thin ? 1 : 1.5);
		trace(c, a.pts, n); c.stroke();
		var ex = a.pts[2 * n - 2], ey = a.pts[2 * n - 1];
		c.globalAlpha = a.alpha;
		c.fillStyle = thin ? 'rgba(255,255,255,.6)' : col;
		if (!thin) { c.shadowColor = hexA(col, 0.6); c.shadowBlur = 6; }
		c.beginPath(); c.arc(ex, ey, thin ? 2 : 3, 0, TAU); c.fill();
		c.shadowBlur = 0;
		tagBoxes.push({ a: a, t: tagOf(a.name), x: ex + 4, cy: ey, y: 0, w: 0, h: 12, n: n, col: thin ? 'rgba(255,255,255,.85)' : col });
	}
	c.globalAlpha = 1;
	var tc = TIER_LINE[session.tier], yn = buildPts(you, ax, pxs, base, span), yp = you.pts;
	trace(c, yp, yn); c.lineTo(ax, base); c.lineTo(yp[0], base); c.closePath();
	var fg = c.createLinearGradient(0, 0, 0, h);
	fg.addColorStop(0, hexA(tc, 0.32)); fg.addColorStop(0.55, hexA(tc, 0.08)); fg.addColorStop(1, hexA(tc, 0));
	c.fillStyle = fg; c.fill();
	trace(c, yp, yn); c.strokeStyle = hexA(tc, 0.22); c.lineWidth = 9; c.stroke();
	c.strokeStyle = tc; c.lineWidth = 2.4; c.stroke();
	var dy = yp[2 * yn - 1];
	c.fillStyle = hexA(tc, 0.3); c.shadowColor = tc; c.shadowBlur = 14;
	c.beginPath(); c.arc(ax, dy, 9, 0, TAU); c.fill();
	c.shadowBlur = 8; c.fillStyle = tc;
	c.beginPath(); c.arc(ax, dy, 3.5, 0, TAU); c.fill();
	c.shadowBlur = 0;
	var GAP = 12;
	tagBoxes.sort(function (p1, p2) { return p1.cy - p2.cy; });
	for (i = 1; i < tagBoxes.length; i++) { if (tagBoxes[i].cy - tagBoxes[i - 1].cy < GAP) { tagBoxes[i].cy = tagBoxes[i - 1].cy + GAP; } }
	if (tagBoxes.length && tagBoxes[tagBoxes.length - 1].cy > base - 6) {
		tagBoxes[tagBoxes.length - 1].cy = base - 6;
		for (i = tagBoxes.length - 2; i >= 0; i--) { if (tagBoxes[i].cy > tagBoxes[i + 1].cy - GAP) { tagBoxes[i].cy = tagBoxes[i + 1].cy - GAP; } }
	}
	c.font = TAGFONT; c.textBaseline = 'middle'; c.textAlign = 'left'; c.lineJoin = 'round';
	c.strokeStyle = 'rgba(5,14,24,.9)'; c.lineWidth = 3;
	for (i = 0; i < tagBoxes.length; i++) {
		var tb = tagBoxes[i];
		c.globalAlpha = tb.a.alpha;
		c.strokeText(tb.t, tb.x + 2, tb.cy + 0.5);
		c.fillStyle = tb.col; c.fillText(tb.t, tb.x + 2, tb.cy + 0.5);
		tb.w = c.measureText(tb.t).width + 6; tb.y = tb.cy - 7; tb.h = 14;
	}
	tagBoxes = tagBoxes.filter(function (tb) { return !tb.a.leaving; });
	c.globalAlpha = 1;
}
function buildDialStatic() {
	var r = el.dcv._r || 1, S = 272, cx = 136, cy = 136, sr = 120, dr = sr - 6.5;
	var cv = document.createElement('canvas');
	cv.width = el.dcv.width; cv.height = el.dcv.height;
	var c = cv.getContext('2d');
	c.setTransform(r, 0, 0, r, 0, 0);
	c.strokeStyle = 'rgba(255,209,87,.16)'; c.lineWidth = 1;
	c.beginPath(); c.arc(cx, cy, sr + 12.5, 0, TAU); c.stroke();
	c.strokeStyle = 'rgba(255,255,255,.06)'; c.lineWidth = 11;
	c.beginPath(); c.arc(cx, cy, sr, 0, TAU); c.stroke();
	c.save();
	c.shadowColor = 'rgba(0,0,0,.45)'; c.shadowBlur = 26; c.shadowOffsetY = 11;
	var g = c.createRadialGradient(cx, cy - dr * 0.44, 0, cx, cy - dr * 0.1, dr * 1.25);
	g.addColorStop(0, '#17273F'); g.addColorStop(1, '#0A1220');
	c.fillStyle = g; c.beginPath(); c.arc(cx, cy, dr, 0, TAU); c.fill();
	c.restore();
	c.strokeStyle = 'rgba(255,255,255,.1)'; c.lineWidth = 1;
	c.beginPath(); c.arc(cx, cy, dr - 0.5, 0, TAU); c.stroke();
	var hw = dr * 1.32, hh = dr * 0.7, hx = cx - hw / 2, hy = cy - dr + 9;
	var hg = c.createLinearGradient(0, hy, 0, hy + hh);
	hg.addColorStop(0, 'rgba(255,255,255,.07)'); hg.addColorStop(1, 'rgba(255,255,255,0)');
	c.fillStyle = hg; c.beginPath(); c.ellipse(cx, hy + hh / 2, hw / 2, hh / 2, 0, 0, TAU); c.fill();
	c.setLineDash([4, 3]); c.lineWidth = 4; c.strokeStyle = 'rgba(255,255,255,.08)';
	c.beginPath(); c.arc(cx, cy, dr - 7, -Math.PI / 2, Math.PI * 1.5); c.stroke();
	c.setLineDash([]);
	c.shadowColor = 'rgba(255,209,87,.85)'; c.shadowBlur = 12; c.fillStyle = '#FFD157';
	c.beginPath(); c.arc(cx, cy - sr, 3.5, 0, TAU); c.fill();
	dialStatic = cv;
}
function drawDial() {
	var c = dctx, r = el.dcv._r || 1;
	if (!dialStatic || dialStatic.width !== el.dcv.width) { buildDialStatic(); }
	c.setTransform(1, 0, 0, 1, 0, 0);
	c.clearRect(0, 0, el.dcv.width, el.dcv.height);
	c.drawImage(dialStatic, 0, 0);
	c.setTransform(r, 0, 0, r, 0, 0);
	var frac = clamp(you.sm / 13, 0, 1);
	if (frac > 0.004) {
		var arc = TIER_ARC[session.tier];
		c.setLineDash([4, 3]); c.lineWidth = 4; c.strokeStyle = arc[0];
		c.shadowColor = arc[1]; c.shadowBlur = 10;
		c.beginPath(); c.arc(136, 136, 106.5, -Math.PI / 2, -Math.PI / 2 + frac * TAU); c.stroke();
		c.setLineDash([]); c.shadowBlur = 0;
	}
}

var paceAt = -9, promptSig = '', stripSig = '', stripW = 0, lastTierShown = -1;
function renderPrompt() {
	var kind = prompt.ev ? 'event' : (!room.length ? 'solo' : (tipsOn ? 'tips' : 'quiet'));
	var ico, head, sub, acts = '', headW = '';
	if (kind === 'event') {
		var w = prompt.ev.who;
		ico = '🎯'; head = esc(w.name.toUpperCase()) + ' HIT THE POCKET'; headW = seams(w.name, true) + ' HIT THE POCKET'; sub = 'Send some love — one tap';
		acts = prompt.ev.props.map(function (ph, i) {
			return '<button type="button" class="fs-pr-b is-emo" data-pp="' + i + '" aria-label="Send ' + esc(wordsOf(ph)) + ' to ' + esc(w.name) + '">' + esc(emojiOf(ph)) + '</button>';
		}).join('');
	} else if (kind === 'solo') {
		ico = '👋'; head = 'TRAINING SOLO'; sub = 'Invite a friend to train with you';
		acts = '<button type="button" class="fs-pr-b" data-act="invite">INVITE</button>';
	} else if (kind === 'tips') {
		var t = TIPS[tipI];
		ico = t[0]; head = esc(t[1] || ('POCKET ' + lane.lo + '–' + lane.hi + ' ▾')); sub = t[2];
		acts = '<button type="button" class="fs-pr-b is-got" data-act="gotit" aria-label="Got it, hide tips">GOT IT ✕</button>';
	} else {
		ico = '🤝'; head = 'BUILD EACH OTHER UP'; sub = 'Tap a name or line to send props';
	}
	var sig = kind + '|' + head + '|' + (prompt.ev ? prompt.ev.props.join() : '');
	if (sig === promptSig) { return; }
	var hadFocus = el.prompt.contains(document.activeElement);
	promptSig = sig;
	el.prompt.classList.toggle('is-quiet', kind === 'solo' || kind === 'quiet');
	el.prompt.innerHTML = '<span class="fs-pr-ico" aria-hidden="true">' + ico + '</span><div class="fs-pr-txt"><div class="fs-pr-h">' + head + '</div><div class="fs-pr-s">' + esc(sub) + '</div></div>' + (acts ? '<div class="fs-pr-acts">' + acts + '</div>' : '');
	fitPrompt(headW || head);
	if (hadFocus) {
		var b = q('button', el.prompt) || el.roomPill;
		focusQ(b);
	}
}
function fitPrompt(wrapHtml) {
	var h = q('.fs-pr-h', el.prompt), s = q('.fs-pr-s', el.prompt), box = q('.fs-pr-txt', el.prompt);
	h.style.fontSize = '12px'; h.classList.remove('is-wrap'); s.hidden = false; s.style.fontSize = '11px'; s.classList.remove('is-wrap');
	if (h.scrollWidth <= box.clientWidth + 0.5) {
		if (s.scrollWidth > box.clientWidth + 0.5) { s.style.fontSize = '10px'; }
		if (s.scrollWidth > box.clientWidth + 0.5) {
			s.classList.add('is-wrap');
			if (h.offsetHeight + s.offsetHeight + 1 > 42) { h.style.fontSize = '11px'; }
			if (h.offsetHeight + s.offsetHeight + 1 <= 42) { return; }
			s.classList.remove('is-wrap'); h.style.fontSize = '12px';
		} else { return; }
	}
	s.hidden = true; h.classList.add('is-wrap'); h.innerHTML = wrapHtml;
	for (var z = 12; z >= 10; z -= 0.5) {
		h.style.fontSize = z + 'px';
		if (h.scrollWidth <= box.clientWidth + 0.5 && h.offsetHeight <= 42) { return; }
	}
}
function renderStrip() {
	var n = room.length, solo = !n;
	var trail = solo ? 'ROOM ▾' : null;
	var sig = (stripEv ? 'E' + stripEv.html : 'C') + '|' + room.map(function (p) { return p.name + (p.hue || ''); }).join(',');
	if (sig === stripSig) { return; }
	stripSig = sig;
	var font12 = '800 12px ' + SANS, font11 = '800 11px ' + SANS;
	var worst = '+' + n + DOT + 'ROOM ' + (n + 1) + ' ▾';
	var pillW = Math.ceil(textW(solo ? 'ROOM ▾' : worst, font11, 0.8)) + 22;
	var avail = CW - 20 - pillW - 6;
	var youTxt = solo ? 'YOU' + DOT + 'SOLO' : 'YOU';
	var youW = Math.ceil(textW(youTxt, '900 12px ' + SANS, 0.9)) + 33;
	if (solo && youW > avail) { youTxt = 'YOU'; youW = Math.ceil(textW('YOU', '900 12px ' + SANS, 0.9)) + 33; }
	var used = youW, shown = [], i;
	for (i = 0; i < n && shown.length < 2; i++) {
		var p = room[i], w = Math.ceil(textW(p.name, font12, 0)) + 33;
		if (used + 6 + w <= avail) { shown.push(p); used += 6 + w; }
	}
	var folded = n - shown.length;
	trail = solo ? 'ROOM ▾' : ((folded ? '+' + folded + DOT : '') + 'ROOM ' + (n + 1) + ' ▾');
	var h = '<span class="fs-chip is-you"><i></i>' + esc(youTxt) + '</span>';
	shown.forEach(function (p) {
		h += '<button type="button" class="fs-chip' + (p.hue ? '' : ' is-white') + '" data-chip="' + esc(p.name) + '" style="--c:' + (p.hue || 'rgba(255,255,255,.85)') + '" aria-label="' + esc(p.name) + ': send props or race">' + '<i></i>' + esc(p.name) + '</button>';
	});
	var hadChip = document.activeElement && el.chips.contains(document.activeElement) ? document.activeElement.getAttribute('data-chip') : null;
	el.chips.innerHTML = h;
	if (hadChip) { var b = q('[data-chip="' + hadChip + '"]', el.chips) || el.roomPill; focusQ(b); }
	el.roomPill.style.minWidth = pillW + 'px';
	setText(el.roomPill, trail);
	el.roomPill.setAttribute('aria-label', solo ? 'Room: training solo' : 'Room: ' + (n + 1) + ' people. Open the room');
	if (stripEv) {
		el.ev.innerHTML = '<span class="fs-ev-t" style="--a:' + stripEv.accent + '">' + stripEv.html + '</span>';
		fitEvent();
		el.strip.classList.add('is-ev');
	} else {
		el.strip.classList.remove('is-ev');
	}
}
function fitEvent() {
	var t = q('.fs-ev-t', el.ev), wmax = el.ev.clientWidth;
	var ladder = [[1, 0], [0.85, 0], [0.8, 1]];
	for (var i = 0; i < ladder.length; i++) {
		t.style.setProperty('--es', ladder[i][0]);
		if (ladder[i][1]) { t.innerHTML = stripEv.htmlW; }
		t.classList.toggle('is-wrap', !!ladder[i][1]);
		if (t.scrollWidth <= wmax + 0.5 && t.offsetHeight <= 31) { return; }
	}
	var ks = qa('.fs-k', t);
	if (ks.length && stripEv && stripEv.tail) { ks[ks.length - 1].remove(); }
}
function renderWall() {
	setSlot(el.wallN, fmt(WALL_TOTAL));
	setText(el.wallC, WALL_CAUSE ? DOT.slice(1) + WALL_CAUSE : '');
	el.wallC.hidden = !WALL_CAUSE;
	var rungs = [1e3, 5e3, 1e4, 25e3, 5e4, 1e5, 25e4, 5e5, 75e4, 1e6], nx = 0;
	for (var i = 0; i < rungs.length && !nx; i++) { if (WALL_TOTAL < rungs[i]) { nx = rungs[i]; } }
	nx = nx || (Math.floor(WALL_TOTAL / 1e6) + 1) * 1e6;
	el.wallBar.style.width = clamp(WALL_TOTAL / nx * 100, 0, 100).toFixed(1) + '%';
	var k = nx >= 1e6 ? (nx / 1e6) + 'M' : (nx / 1e3) + 'K';
	setText(el.wallM, '→ ' + k);
	var r = el.wallR, over = function () { return r.scrollWidth > r.clientWidth + 0.5; };
	r.classList.remove('is-c1', 'is-c2', 'is-c3');
	el.wallM.hidden = false;
	if (!over()) { return; }
	el.wallM.hidden = true;
	['is-c1', 'is-c2', 'is-c3'].forEach(function (c) { if (over()) { r.classList.add(c); } });
}
var lastPlot = -9, lastDial = -9, lastSheet = -9;
function render(force) {
	var now = T;
	if (force || !reduced || now - lastPlot >= 1) { drawPlot(); lastPlot = now; }
	if (force || !reduced || now - lastDial >= 0.25) { drawDial(); lastDial = now; }
	var tr = session.tier;
	if (tr !== lastTierShown) {
		el.card.classList.remove('fs-t0', 'fs-t1', 'fs-t2', 'fs-t3');
		el.card.classList.add('fs-t' + tr);
		setText(el.badge, TIER_WORD[tr]);
		if (lastTierShown >= 0 && tr > lastTierShown) { restartAnim(el.badge, 'is-pop'); }
		lastTierShown = tr;
	}
	if (force || now - paceAt >= 0.16) { setSlot(el.paceN, you.sm.toFixed(1)); paceAt = now; }
	setText(el.pill, 'POCKET ' + lane.lo + '–' + lane.hi + ' ▾');
	var on = session.inPocket && session.flow >= 1;
	if (el.streak.classList.contains('is-on') !== on) { el.streak.classList.toggle('is-on', on); }
	if (on) { setSlot(el.streakN, mss(session.flow)); }
	setText(el.peak, session.peak.toFixed(1));
	if (session.inPocket) {
		setText(el.flowK, 'FLOW'); setText(el.flow, mss(session.flow));
		el.flow.className = 'fs-flow is-live';
	} else {
		setText(el.flowK, 'BEST FLOW'); setText(el.flow, mss(session.best));
		el.flow.className = 'fs-flow' + (session.best >= 1 ? ' is-pos' : '');
	}
	var cs = String(session.hits);
	if (el.count._v !== cs) { el.count.style.fontSize = (cs.length > 4 ? Math.floor(104 * 4 / cs.length) : 104) + 'px'; }
	setSlot(el.count, cs);
	setSlot(el.clock, mss(T));
	renderPrompt();
	renderStrip();
	if (sheetOpen && (force || now - lastSheet >= 0.5)) { renderSheet(false); lastSheet = now; }
}

function chartTap(e) {
	var b = el.cv.getBoundingClientRect();
	var x = (e.clientX - b.left) * (CW / b.width), y = (e.clientY - b.top) * (PH / b.height);
	var best = null, bd = 22, i, k;
	for (i = 0; i < tagBoxes.length; i++) {
		var tb = tagBoxes[i];
		if (x >= tb.x && x <= tb.x + tb.w && y >= tb.y && y <= tb.y + tb.h) { best = tb.a; bd = 0; }
	}
	if (!best) {
		for (i = 0; i < tagBoxes.length; i++) {
			var a = tagBoxes[i].a, p = a.pts, n = tagBoxes[i].n;
			if (a.alpha < 0.2) { continue; }
			for (k = 1; k < n; k++) {
				var x1 = p[2 * k - 2], y1 = p[2 * k - 1], x2 = p[2 * k], y2 = p[2 * k + 1];
				var dx = x2 - x1, dy = y2 - y1, L = dx * dx + dy * dy, t = L ? clamp(((x - x1) * dx + (y - y1) * dy) / L, 0, 1) : 0;
				var ddx = x - (x1 + t * dx), ddy = y - (y1 + t * dy), d = Math.sqrt(ddx * ddx + ddy * ddy);
				if (d < bd) { bd = d; best = a; }
			}
		}
	}
	if (best) {
		pickLine(best, true);
	} else if (room.length && !hintShown) {
		hintShown = true;
		strip({ lead: 'TAP A LINE OR A NAME', accent: '#FFD157', dur: 1.6 });
		render(true);
	}
}
function pickLine(p, fromInside) {
	p.flash = T;
	openSheet(p.name, fromInside);
	render(true);
}
function toggleRow(name) {
	expandedName = expandedName === name ? null : name;
	sheetTouch = T;
	qa('.fs-row', el.list).forEach(function (r) {
		var open = r.getAttribute('data-n') === expandedName;
		r.classList.toggle('is-open', open);
		q('.fs-panel', r).hidden = !open;
		q('.fs-row-tog', r).setAttribute('aria-expanded', open ? 'true' : 'false');
	});
	rowsSig = rowsSig.replace(/[^#]*$/, '') + sheetFilter + el.search.value.trim().toLowerCase() + expandedName;
	var r0 = expandedName && rowFor(expandedName);
	if (r0) {
		var bottom = r0.offsetTop - el.list.offsetTop + r0.offsetHeight, view = el.list.scrollTop + el.list.clientHeight;
		if (bottom > view) { el.list.scrollTop += Math.min(bottom - view + 8, r0.offsetTop - el.list.offsetTop - el.list.scrollTop - 4); }
	}
}

root.addEventListener('click', function (e) {
	var t = e.target;
	if (!(t instanceof Element) || !el.phone.contains(t)) { return; }
	var btn = t.closest('button');
	var act = btn ? btn.getAttribute('data-act') : null;
	if (sheetOpen) { sheetTouch = T; }
	if (t === el.catcher || t === el.scrim) { closeSheet(true); return; }
	if (menuOpen && !el.menu.contains(t) && btn !== el.pill) { closeMenu(false); if (el.plot.contains(t) && !btn) { return; } }
	if (btn && btn.classList.contains('fs-mi')) {
		var li = +btn.getAttribute('data-lane');
		closeMenu(true);
		if (li !== laneIdx) { setLane(li, true); render(true); }
		return;
	}
	if (btn && btn.hasAttribute('data-pp') && prompt.ev) {
		sendProps(prompt.ev.who, prompt.ev.props[+btn.getAttribute('data-pp')], 'bar'); render(true); return;
	}
	if (btn && btn.hasAttribute('data-chip')) { var cp = byName(btn.getAttribute('data-chip')); if (cp) { openSheet(cp.name, true); } return; }
	if (btn && el.list.contains(btn)) {
		var row = btn.closest('.fs-row'), who = row && byName(row.getAttribute('data-n'));
		if (!who) { return; }
		if (btn.classList.contains('fs-row-tog') || btn.classList.contains('fs-chev')) { toggleRow(who.name); return; }
		if (btn.classList.contains('fs-qp')) { sendProps(who, PROPS[+btn.getAttribute('data-p')], 'row'); render(true); return; }
		if (btn.classList.contains('fs-pp')) { sendProps(who, PROPS[+btn.getAttribute('data-p')], 'row'); render(true); return; }
		if (act === 'race') { note('IN THE APP', 'Pick a race, and ' + who.name + ' gets your challenge. Races need a connected bag.'); say('In the app, CHALLENGE TO A RACE sends ' + who.name + ' a live race challenge.'); return; }
	}
	if (btn && btn.classList.contains('fs-flt')) {
		sheetFilter = btn.getAttribute('data-f');
		qa('.fs-flt').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
		renderSheet(false); return;
	}
	switch (act) {
		case 'pocket': if (menuOpen) { closeMenu(true); } else { openMenu(e.detail === 0); } return;
		case 'room': openSheet(null, true); render(true); return;
		case 'close': closeSheet(true); return;
		case 'gotit': tipsOn = false; promptSig = ''; render(true); var rb = q('button', el.prompt) || el.roomPill; if (document.activeElement === document.body || !root.contains(document.activeElement)) { focusQ(rb); } return;
		case 'invite': note('IN THE APP', 'Invite a friend to train with you. When they start, their line rides your graph.'); return;
		case 'camera': note('IN THE APP', 'The camera records you on the bag while the session keeps counting.'); return;
		case 'partner': note('IN THE APP', 'Pick a friend to train with. Up to 10 training partners, and every line is a real person.'); return;
		case 'stop': note('IN THE APP', 'STOP ends your session. This demo keeps going.'); return;
		case 'expand': setExpanded(!el.phone.classList.contains('is-exp')); return;
	}
	if (!btn && el.strip.contains(t)) { openSheet(null, true); render(true); return; }
	if (t === el.cv) { chartTap(e); }
});
el.search.addEventListener('input', function () { sheetTouch = T; renderSheet(false); });
['pointerdown', 'pointermove', 'wheel', 'keydown', 'focusin'].forEach(function (ev) {
	el.sheet.addEventListener(ev, function () { sheetTouch = T; }, { passive: true });
});
el.list.addEventListener('scroll', function () { sheetTouch = T; }, { passive: true });
root.addEventListener('keydown', function (e) {
	if (e.key === 'Escape') {
		if (menuOpen) { closeMenu(true); e.preventDefault(); } else if (sheetOpen) { closeSheet(true); var f = el.roomPill; focusQ(f); e.preventDefault(); }
		return;
	}
	if (menuOpen && (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'Home' || e.key === 'End')) {
		var items = qa('.fs-mi', el.menu), i = items.indexOf(document.activeElement);
		if (e.key === 'Home') { i = 0; } else if (e.key === 'End') { i = items.length - 1; }
		else { i = (i + (e.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length; }
		items[i].focus(); e.preventDefault();
	}
	if (menuOpen && e.key === 'Tab') { closeMenu(false); }
});
function setExpanded(on) {
	closeMenu(false);
	el.phone.classList.toggle('is-exp', on);
	el.expand.setAttribute('aria-pressed', on ? 'true' : 'false');
	el.expand.setAttribute('aria-label', on ? 'Exit full screen card' : 'Full screen card');
	el.stop2.hidden = !on;
	fitAll();
	if (sheetOpen) { layoutSheet(); }
	render(true);
}

var lastRootW = -1;
function fitAll() {
	dpr = Math.min(3, window.devicePixelRatio || 1);
	PH = el.plot.clientHeight || 142;
	fitCanvas(el.cv, CW, PH);
	fitCanvas(el.dcv, 272, 272);
	dialStatic = null;
}
function layout(force) {
	var w = root.clientWidth;
	if (!force && w === lastRootW) { return; }
	lastRootW = w;
	var cls = w < 520 ? 'xs' : (w < 860 ? 'sm' : (w < 1040 ? 'md' : 'lg'));
	if (root.getAttribute('data-w') !== cls) { root.setAttribute('data-w', cls); }
	var sw = el.stage.clientWidth || DW;
	scale = Math.min(420, sw) / DW;
	TAGFONT = (scale < 0.99 ? '800 10px ' : '800 9px ') + SANS;
	el.fit.style.width = (DW * scale).toFixed(2) + 'px';
	el.fit.style.height = (DH * scale).toFixed(2) + 'px';
	el.phone.style.transform = 'scale(' + scale.toFixed(4) + ')';
	fitAll();
	stripSig = ''; promptSig = '';
	renderWall();
	render(true);
}
var rafL = 0;
function scheduleLayout() {
	if (rafL) { return; }
	rafL = requestAnimationFrame(function () { rafL = 0; layout(false); });
}
if ('ResizeObserver' in window) { new ResizeObserver(scheduleLayout).observe(root); }
else { window.addEventListener('resize', scheduleLayout); }
function fontCheck() {
	if (!document.fonts || !document.fonts.load) { return; }
	document.fonts.load('400 40px "Bebas Neue"').then(function (faces) {
		if (!faces || !faces.length) { root.classList.add('fs-nobebas'); }
		layout(true);
	}, function () { root.classList.add('fs-nobebas'); });
}
if (document.readyState === 'complete') { fontCheck(); } else { window.addEventListener('load', fontCheck); }

var raf = 0, last = 0, acc = 0, inView = !('IntersectionObserver' in window), userPaused = false;
function frame(now) {
	raf = requestAnimationFrame(frame);
	var dt = Math.min(0.25, Math.max(0, (now - last) / 1000));
	last = now; acc += dt;
	var steps = 0;
	while (acc >= DT && steps < 10) { simStep(); acc -= DT; steps++; }
	if (steps) { render(false); }
}
function sync() {
	var go = inView && !document.hidden && !userPaused;
	if (go && !raf) { last = performance.now(); acc = 0; raf = requestAnimationFrame(frame); }
	else if (!go && raf) { cancelAnimationFrame(raf); raf = 0; }
}
if (!inView) {
	new IntersectionObserver(function (entries) { inView = entries[entries.length - 1].isIntersecting; sync(); }, { threshold: 0 }).observe(root);
}
document.addEventListener('visibilitychange', sync);
if ('IntersectionObserver' in window) {
	sheetVis = false;
	new IntersectionObserver(function (entries) {
		var e = entries[entries.length - 1];
		sheetVis = e.isIntersecting && e.intersectionRatio >= 0.5;
	}, { threshold: [0, 0.5, 1] }).observe(el.sheet);
}
function ff(sec) { var n = Math.round(sec * HZ); for (var i = 0; i < n; i++) { simStep(); } }

var pauseBtn = q('[data-sc="pause"]'), tapIdx = 0;
function setPaused(on) {
	userPaused = on;
	pauseBtn.classList.toggle('is-on', on);
	root.classList.toggle('is-paused', on);
	setText(el.tagT, on ? 'FREESTYLE\u00a0· PAUSED' : 'FREESTYLE\u00a0· LIVE DEMO');
	setText(q('.fs-try-t', pauseBtn), on ? 'Play' : 'Pause');
	setText(q('.fs-try-s', pauseBtn), on ? 'Pick up where it stopped' : 'Freeze the demo');
	sync();
}
function settle() { you.mode = 'pocket'; you.until = T + 22; }
function scenario(kind) {
	if (kind === 'pause') { setPaused(!userPaused); say(userPaused ? 'Demo paused.' : 'Demo playing.'); return; }
	if (userPaused) { setPaused(false); }
	closeMenu(false);
	cancelJobs('pocket');
	var p, i;
	if (kind === 'fire') {
		closeSheet(false);
		you.mode = 'fire'; you.fireT = lane.hi >= 11 ? 11.9 : 10.7; you.until = T + 7;
		if (reduced) { ff(2.5); }
		say('ON FIRE: 9.5 punches a second or more, above your pocket. Pace, badge, line and card glow orange.');
	} else if (kind === 'pocket') {
		closeSheet(false);
		if (session.inPocket) {
			you.mode = 'script'; you.focus = Math.max(3.2, lane.lo - 1.7); you.until = T + 30;
			later(1.5, settle, 'pocket');
			if (reduced) { ff(1.6); }
		} else { settle(); }
		if (reduced) { ff(3.5); }
		say('IN THE POCKET: your pace is inside the teal lane (' + lane.lo + RD + lane.hi + ' P/S). Hold it and the streak clock runs.');
	} else if (kind === 'lane') {
		closeSheet(false);
		var next = laneIdx === 1 ? 2 : (laneIdx === 2 ? 0 : 1);
		if (reduced) { setLane(next, true); }
		else {
			openMenu(false);
			var mi = q('.fs-mi[data-lane="' + next + '"]', el.menu);
			clearTimeout(menuDemo);
			menuDemo = setTimeout(function () { mi.classList.add('is-hi'); menuDemo = setTimeout(function () { closeMenu(false); setLane(next, true); render(true); }, 420); }, 380);
		}
	} else if (kind === 'buddy') {
		closeSheet(false);
		if (!room.length) { cancelJobs('arrive'); restoreBase(false); ff(0.1); }
		var cands = charted().filter(function (x) { return !inLane(x.sm) && T - (gate.by[x.name] || -999) >= 60; });
		if (!cands.length) { cands = charted().filter(function (x) { return !inLane(x.sm); }); }
		if (!cands.length) { cands = charted(); }
		cands.sort(function (a, b) { return Math.abs(a.sm - laneMid()) - Math.abs(b.sm - laneMid()); });
		p = cands[0];
		room.forEach(function (x) { if (x !== p && inLane(x.sm)) { x.considered = true; } });
		p.mode = 'drive'; p.until = T + 14; p.from = Math.min(p.from, T); p.inSince = -1; p.considered = false;
		gate.lastAt = -999; gate.by[p.name] = -999; prompt.ev = null; promptSig = '';
		pendingBuddy = p;
		say('Watch ' + p.name + '’s line ride into your pocket. After 2 seconds there, the prompt bar lights up.');
		if (reduced) { for (i = 0; i < 12 && !prompt.ev; i++) { ff(0.5); } }
	} else if (kind === 'tap') {
		if (!room.length) {
			cancelJobs('arrive'); restoreBase(false);
			room.forEach(function (x) { x.from = T - 7; });
			ff(3.5);
		}
		var ch = charted().filter(function (x) { return x.hn > 8; });
		if (!ch.length) { ch = charted(); }
		p = ch[tapIdx++ % ch.length];
		pickLine(p, false);
		say(p.name + '’s line flashes white and their panel opens: 8 props and a race challenge.');
	} else if (kind === 'crowd') {
		closeSheet(false);
		if (room.length >= 10) {
			cancelJobs('arrive');
			room.slice().forEach(function (x) { if (!START_ROOM.some(function (d) { return d.name === x.name; })) { removePartner(x); } });
			restoreBase(false);
			say('Back to 4 people in the room. The newcomers’ lines and names drop away.');
		} else {
			cancelJobs('arrive');
			restoreBase(false);
			var j = 0;
			ARRIVALS.forEach(function (d) {
				if (byName(d.name)) { return; }
				later(0.5 + (j++) * 0.85, function () { if (!byName(d.name)) { addPartner(d, true); } }, 'arrive');
			});
			say('The room fills to 11. The graph keeps 6 partner lines plus yours; ROOM ▾ lists the other 10, with search.');
			if (reduced) { ff(0.6 + j * 0.85); }
		}
		syncToggles();
	} else if (kind === 'solo') {
		closeSheet(false);
		if (room.length || jobs.some(function (x) { return x.tag === 'arrive'; })) {
			everyoneLeaves();
			say('Everyone else heads out. The prompt bar offers INVITE, and the tips step aside.');
		} else {
			restoreBase(true);
			say('Three people come back on. Their lines climb off the floor as they warm up.');
			if (reduced) { ff(2.8); }
		}
		syncToggles();
	}
	render(true);
	if (kind !== 'tap') { revealCard(); }
}
qa('[data-sc]').forEach(function (b) {
	b.addEventListener('click', function () { scenario(b.getAttribute('data-sc')); });
});
if (mq) {
	var onMq = function () { reduced = mq.matches; if (reduced) { laneLoD = lane.lo; laneHiD = lane.hi; } render(true); };
	if (mq.addEventListener) { mq.addEventListener('change', onMq); } else if (mq.addListener) { mq.addListener(onMq); }
}

START_ROOM.forEach(function (d) { var p = addPartner(d, false); p.joined = 0; p.from = d.from; });
stripEv = null;
var plan = [[0, 4.9], [10, 9.9], [20.5, 8.1], [39.5, 6.2], [50.5, 8.05]];
you.mode = 'script';
plan.forEach(function (s) { later(s[0], function () { you.focus = s[1]; }, 'plan'); });
ff(58);
you.mode = 'pocket'; you.until = T + 12;
gate.lastAt = T - 6;
room.forEach(function (x) { x.considered = inLane(x.sm); });
tipI = 0; tipNext = T + 4.5;
roomChanged();
layout(true);
renderWall();
render(true);
sync();
})();


(function(){
var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;var vids=[].slice.call(document.querySelectorAll('.sbcv2 video'));
if(reduce){vids.forEach(function(v){v.removeAttribute('autoplay');v.pause();});}else if('IntersectionObserver' in window){var io=new IntersectionObserver(function(es){es.forEach(function(e){var v=e.target;if(e.isIntersecting){if(v.preload==='none')v.preload='auto';var p=v.play();if(p&&p.catch)p.catch(function(){});}else{v.pause();}});},{threshold:.25});vids.forEach(function(v){io.observe(v);});}
var rs=document.getElementById('relaySound'),rv=document.getElementById('relay');if(rs&&rv)rs.addEventListener('click',function(){var on=rv.muted;rv.muted=!on;if(on){rv.currentTime=0;rv.play().catch(function(){});}rs.setAttribute('aria-pressed',String(on));rs.innerHTML=on?'&#10073;&#10073; Mute':'&#9654; Sound on';});

})();
